import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

/**
 * Monkids Step By Step
 */

// Wait for document
document.addEventListener( 'DOMContentLoaded', function() {
	jQuery( '.sbs-info-trigger' ).each( function() {
		const popupIndex = jQuery( this ).attr( 'data-popup-index' );
		Fancybox.bind( '[data-fancybox' + popupIndex + ']', {
			src: '#sbs-info' + popupIndex,
			type: 'clone',
			autoFocus: false,
			compact: true,
		} );
	} );
} );
